import { render, staticRenderFns } from "./EmojiKeyboard.vue?vue&type=template&id=17b2c221&"
import script from "./EmojiKeyboard.vue?vue&type=script&lang=js&"
export * from "./EmojiKeyboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports